<template>
  <v-dialog v-model="isOpenRoleRemove" max-width="300" persistent>
    <v-card>
      <v-card-title class="headline pa-4">
        {{ 'Eliminar registro' }}
      </v-card-title>
      <v-card-text class="pa-4 text-center">
        ¿Está seguro que desea eliminar el registro?
      </v-card-text>
      <v-card-actions class="pa-4 text-center">
        <v-row dense>
          <v-col cols="6">
            <v-btn
              @click="close()"
              :disabled="loading"
              color="primary"
              text
              block
            >
              {{ $t('actions.cancel') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="submit()"
              :loading="loading"
              color="primary"
              block
            >
              {{ $t('actions.accept') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

const defaultData = ({
  loading: false
})

export default {
  name: 'RoleRemove',
  data: () => defaultData,
  computed: {
    ...mapGetters({
      isOpenRoleRemove: 'roles/isOpenRoleRemove',
      role: 'roles/role'
    })
  },
  methods: {
    ...mapActions({
      removeRole: 'roles/removeRole'
    }),
    ...mapMutations({
      toggleRoleRemove: 'roles/toggleRoleRemove',
      setRole: 'roles/setRole'
    }),
    async submit () {
      const { role, removeRole } = this
      const { id } = role
      this.loading = true
      await removeRole({ id })
      this.loading = false
      this.close()
    },
    setDefaultData () {
      for (const key in defaultData) {
        this[key] = defaultData[key]
      }
    },
    cleanData () {
      this.setDefaultData()
      this.setRole()
    },
    close () {
      this.toggleRoleRemove()
      setTimeout(() => this.cleanData(), 500)
    }
  }
}
</script>
